module.exports = __webpack_public_path__ + "media/images/profile/education-info-afef9952792a4c4a88a8903c0d2a1928.svg";